import { useStore } from 'vuex';

import { useAuthHeader } from './auth-header';

import { AxiosPromise } from 'axios';

export const useTileManagementService = () => {
    const store = useStore();
    const authHeader = useAuthHeader();

    const url = store.state.tileFileServerApiUrl;

    const getFileList = async (subpath = ''): Promise<any> => {
        const res = await authHeader.post(`${url}/file/list`, {subpath});
        return res.data;
    };

    const downloadFile = async (filename:string): Promise<AxiosPromise> => {
        const res = await authHeader.getBlob(`${url}/file/download?filename=${filename}`);
        return res;
    };

    const deleteFile = async (filepath:string): Promise<AxiosPromise> => {
        const res = await authHeader.deleteId(`${url}/file/delete?filepath=${filepath}`);
        return res;
    };

    const uploadFile = async (files:any, subpath = ''): Promise<AxiosPromise> => {
        const formData = new FormData();
        formData.append('subpath', subpath)
        files.forEach((file) => {
            formData.append('files', file);
        });
    
        const res = await authHeader.post(`${url}/file/upload`, formData);

        return res;
    };

    return {
        getFileList,
        downloadFile,
        deleteFile,
        uploadFile,
    };
};
